import React from "react";

import './styles.scss';

import withState from "../../../../../utils/withState";
import Ripple from "../../../../dumb/Ripple";

export default withState((setState, self, onMount) => {
  self.state = {
    ...self.state,
    activeId: self.props.activeId,
    loading: false
  }

  const moveBorder = (id) => {
    setState({
      activeId: id,
      loading: true
    });

    const node = document.getElementById(id);

    if (!node) return;

    setState({width: node.offsetWidth, left: node.offsetLeft});

    setTimeout(() => {
      setState({loading: false});
    }, 250);
  };

  const changeActiveId = (activeId) => {
    self.props.emitter(activeId);
    moveBorder(activeId);
  }

  const onClick = (activeId) => () => changeActiveId(activeId);

  onMount(() => {
    setTimeout(() => {
      moveBorder(self.props.activeId);
    });
  })

  return ((state, props) => {
    const {width, left, activeId, loading} = state;
    const {links, views, viewProps = {}} = props;

    const Content = views[activeId] || (() => <span />);

    return (
      <div className="seclayer-menu">
        <div className="seclayer-menu__head">
          {links.map(({id, name}) => (
            <Ripple
              id={id}
              key={id}
              className={
                'seclayer-menu__head-item'
                + (id === activeId ? ' active' : '')
              }
              onClick={onClick(id)}
            >
              {name}
            </Ripple>
          ))}
          <div
            className="seclayer-menu__head-border"
            style={{width, left}}
          />
        </div>
        <div className="seclayer-menu__content">
          {loading
            ? <span />
            : <Content {...viewProps} />
          }
        </div>
      </div>
    )
  })
});
